export const getDefaultUserAction = state =>
  state.userActions.defaultUserAction;
